<template>
    <fieldset class="field">
        <div class="field-header" v-if="title || $slots.header">
            <legend v-if="title" class="field-title" v-text="title"></legend>
            <slot name="header"></slot>
        </div>
        <div class="field-body">
            <slot></slot>
        </div>
        <div class="field-footer" v-if="$slots.footer">
            <slot name="footer"></slot>
        </div>
    </fieldset>
</template>

<script>
    export default {
        name: 'Field',
        provide() {
            return {
                rootField: this,
            }
        },
        props: {
            title: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            plain: {
                type: Boolean,
                default: false,
            }
        }
    };
</script>

<style lang="scss" scoped>
    .field {
        padding: 0;
        margin: 0;
        border: 0;

        &.is-plain {
            padding: 0;
        }

        &-header {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        &:disabled,
        &.is-disabled {
            .field-header,
            .field-content,
            .field-footer {
                color: gray;
            }
        }
    }

</style>